"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SplitButton = exports.TEST_ID_SPLITTED_BUTTON = void 0;
var theme_ui_1 = require("theme-ui");
var __1 = require("../../..");
var colors_1 = require("../../../theme/colors");
exports.TEST_ID_SPLITTED_BUTTON = "SplitButton";
var SplitButton = function (_a) {
    var onClick = _a.onClick, leftText = _a.leftText, rightText = _a.rightText, _b = _a.csx, csx = _b === void 0 ? {} : _b;
    return (theme_ui_1.jsx(theme_ui_1.Box, { onClick: onClick, sx: __assign({ minWidth: "250px", display: "inline-flex", overflow: "hidden", background: __1.theme.colors.offBlack, cursor: "pointer" }, csx), "data-testid": exports.TEST_ID_SPLITTED_BUTTON },
        theme_ui_1.jsx(theme_ui_1.Flex, { sx: {
                padding: __1.theme.space[1] + "px 15px " + __1.theme.space[1] + "px 35px",
                justifyContent: "center",
                alignItems: "center",
                background: colors_1.gradients.lightToDark,
                transform: "skew(-25deg, 0)",
                marginLeft: "-11px",
                letterSpacing: "0.06em",
                lineHeight: "151.19%",
            } },
            theme_ui_1.jsx(theme_ui_1.Text, { sx: {
                    fontSize: 2,
                    transform: "skew(25deg, 0)",
                } }, leftText)),
        theme_ui_1.jsx(theme_ui_1.Flex, { sx: {
                background: __1.theme.colors.offBlack,
                justifyContent: "center",
                alignItems: "center",
                padding: "10px 20px 10px 15px",
                fontSize: "14px",
                letterSpacing: "0.055em",
                lineHeight: "151.19%",
                flex: 1,
            } },
            theme_ui_1.jsx(theme_ui_1.Text, { sx: {
                    fontSize: 1,
                } }, rightText))));
};
exports.SplitButton = SplitButton;
